import { useEffect, useRef, useState } from "react";
import { FaShippingFast } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey } from "../CommonComponents/CustomHooks";
import { FormButton, InputBox } from "../CommonComponents/InputBox";
import { TrackingHistoryStepper, TrackingHistoryTimeline } from "./TrackingChart";
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Image } from 'antd';
import { useNavigate } from "react-router-dom";
const Tracking = ({ menuText }) => {
    const location = useLocation();
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const searchParams = new URLSearchParams(location.search);
    const headerTrackingNumber = searchParams.get('awbNumber');

    const [formData, setFormData] = useState({ awbNo: "" });
    const [trackingData, setTrackingData] = useState(null);

    const handleClear = () => {
        setFormData({ awbNo: "" });
        setTrackingData(null);
        inputrefs.current['txtAwbNumber']?.focus();
    };

    const getAnotherTrackData = async (value) => {
        const data = {
            "PageIndex": "1",
            "PageSize": "10",
            "Type": "S",
            "SortColumn": "",
            "SortOrder": "",
            awbNo: value ? value : formData?.awbNo,
        };
        await dispatch(setSubLoading(true));
        let res = await ApiCall(`/api/Tracking/AwbNoTracking`, data);
        await dispatch(setSubLoading(false));
        if (res.status === "SUCCESS" || res.Status === "SUCCESS") {
            setTrackingData(res);
        }
        else {
            await NotificationSound(res.Status || res.status, res.Message || res.message, res.focus, inputrefs);
            setTrackingData(null)
        }
    };

    const handleSubmit = () => {
        getAnotherTrackData()
    }
    const shipment = trackingData?.data?.[0] ?? null;
 
    const basic = shipment?.basicDetails ?? null;
    const movements = Array.isArray(shipment?.momentDetails) ? shipment.momentDetails : [];
    const documents = Array.isArray(basic?.documentFile) ? basic.documentFile : [];

    const getStatusBadge = (status) => {
        const map = {
            DELIVERED: "badge bg-success",
            INTRANSIT: "badge bg-warning text-dark",
            PENDING: "badge bg-secondary",
            CANCELLED: "badge bg-danger",
        };
        const key = status?.toUpperCase().replace(/\s/g, '');
        return <span className={map[key] ?? "badge bg-primary"}>{status}</span>;
    };


    const fields = basic ? [
        { label: 'AWB No', value: basic.awbNo },
        { label: 'Reference No', value: basic.refNo },
        { label: 'Booking Type', value: basic.bookingType },
        { label: 'Pickup Date', value: basic.pickupDate },
        { label: 'Pickup Status', value: getStatusBadge(basic.pickupStatus) },
        { label: 'Payment Mode', value: basic.paymentMode },
        { label: 'Client', value: basic.client },
        { label: 'Consignor', value: basic.consignor },
        { label: 'Consignee', value: basic.consignee },
        { label: 'Vendor', value: basic.vendor },
        { label: 'Actual Weight', value: basic.actualWeight },
        { label: 'Vol. Weight', value: basic.volumetricWeight },
        { label: 'Charged Weight', value: basic.chargedWeight },
        { label: 'Amount', value: basic.amount },
        { label: 'Forwarding No', value: basic.forwardingNo },
    ] : [];


    const [showModalBox, setShowModalBox] = useState(false);
    const [fileExtension, setFileExtension] = useState('');
    const [base64FileData, setBase64FileData] = useState('');

    const base64ToBlob = (base64, mime) => {
        const byteChars = atob(base64);
        const byteArrays = [];
        for (let offset = 0; offset < byteChars.length; offset += 512) {
            const slice = byteChars.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length).fill(0).map((_, i) => slice.charCodeAt(i));
            byteArrays.push(new Uint8Array(byteNumbers));
        }
        return new Blob(byteArrays, { type: mime });
    };

    const generatePdfUrl = (base64) => {
        return URL.createObjectURL(base64ToBlob(base64, 'application/pdf'));
    };

    const generateImageUrl = (base64) => {
        return `data:image/${fileExtension};base64,${base64}`;
    };

    const handleShowDoc = (base64, ext) => {
        setFileExtension(ext);
        setBase64FileData(base64);
        setShowModalBox(true);
    };

    const handleModalDocShowClose = async () => {
        await setShowModalBox(false)
        await setFileExtension('')
        await setBase64FileData('')
    };
    const handleDownload = (fileBase, fileName, fileExt) => {
        const link = document.createElement("a");

        let mimeType = "application/octet-stream";

        if (fileExt === "PDF") mimeType = "application/pdf";
        if (["PNG", "JPG", "JPEG"].includes(fileExt)) {
            mimeType = `image/${fileExt.toLowerCase()}`;
        }

        link.href = `data:${mimeType};base64,${fileBase}`;
        link.download = fileName || `file.${fileExt.toLowerCase()}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    useEffect(() => {
        if (headerTrackingNumber) {
            setFormData(prev => ({ ...prev, awbNo: headerTrackingNumber }));
            getAnotherTrackData(headerTrackingNumber)
        }
    }, [headerTrackingNumber]);

    useEffect(() => {
        document.title = 'Tracking';
    }, []);


    return (
        <>
            <div className="main-card card border-0">
                <div className="card-header mb-1">
                    <h6 className="m-0">
                        {menuText ? menuText : FindTranslatedKey('Tracking')}
                    </h6>
                </div>

                <div className="card-body">

                    {/* ── Search Row ── */}
                    <div className="row align-items-end">
                        <InputBox
                            label="AWB No./Reference No."
                            inputrefs={inputrefs}
                            id="txtAwbNumber"
                            PlaceHolderText="AWB No./Reference No."
                            value={formData.awbNo}
                            maxLength="25"
                            onChange={(e) => setFormData({ ...formData, awbNo: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') inputrefs.current['btnSub']?.focus();
                            }}
                        />
                        <div className="col-md-4 mt-3">
                            <FormButton
                                id="btnSub"
                                Search={true}
                                handleSubmit={handleSubmit}
                                save={false}
                                Export={false}
                                handleClear={handleClear}
                                inputrefs={inputrefs}
                            />
                        </div>
                    </div>

                    {/* ── Shipment Detail ── */}
                    {basic && (
                        <div className="card border mt-4">
                            <div className="card-header d-flex align-items-center justify-content-between py-2">
                                <h6 className="m-0 d-flex align-items-center gap-2">
                                    <FaShippingFast className='text-success' />
                                    {FindTranslatedKey('Shipment Detail')}
                                    {trackingData?.data?.[0]?.isPickupRequestApproved ? <>
                                        {basic?.awbNo && (
                                            <i onClick={() => navigate(`/LabelPrint?awbNumber=${basic.awbNo}`)} class="fa-solid fa-print"></i>
                                        )}
                                    </> : <>
                                    </>}
                                   
                                </h6>
                                <div>
                                {basic?.refNo && (
                                    <span className="badge bg-primary">
                                        Customer Ref No: {basic.refNo}
                                    </span>
                                )}

                                   
                                </div>
                            </div>

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mb-0">
                                        <tbody>
                                            {Array.from({ length: Math.ceil(fields?.length / 2) }).map((_, rowIdx) => (
                                                <tr key={rowIdx}>
                                                    {fields.slice(rowIdx * 2, rowIdx * 2 + 2).map((field, colIdx) => (
                                                        <>
                                                            <th key={`l${colIdx}`} className="bg-light fw-semibold" style={{ width: '15%', fontSize: '12px' }} >  {FindTranslatedKey(field.label)} </th>
                                                            <td
                                                                key={`v${colIdx}`}
                                                                style={{  width: '35%', fontSize: '13px', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                                            >
                                                                {field.value || <span className="text-muted">—</span>}
                                                            </td>
                                                        </>
                                                    ))}
                                                    {fields.slice(rowIdx * 2, rowIdx * 2 + 2).length < 2 &&
                                                        Array.from({
                                                            length: 2 - fields.slice(rowIdx * 2, rowIdx * 2 + 2).length,
                                                        }).map((_, ei) => (
                                                            <>
                                                                <th key={`el${ei}`} className="bg-light"></th>
                                                                <td key={`ev${ei}`}></td>
                                                            </>
                                                        ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {documents?.length > 0 && (
                                <div className="p-1 border-top">
                                    <h6 className="mb-2" style={{ fontSize:'13px' }}>Documents</h6>

                                    <div className="d-flex flex-wrap gap-2" style={{  }}>
                                        {documents?.map((file, index) => (
                                            <div key={index} className="border rounded p-1 text-center" style={{ width: '100px', cursor: 'pointer', backgroundColor: '#dbe7fd' }} >
                                                     {["JPG", "PNG", "JPEG"].includes(file.uploadExt) ? (
                                                    <Image  width={50}
                                                        src={`data:image/${file.uploadExt.toLowerCase()};base64,${file.uploadFileBase}`}
                                                    />
                                                ) : file.uploadExt === "PDF" ? (
                                                    <div onClick={() => handleShowDoc(file.uploadFileBase, file.uploadExt)}>
                                                        <i className="fa-solid fa-file-pdf text-danger" style={{ fontSize: '25px' }}></i>
                                                    </div>
                                                ) : (
                                                    <i className="fa-solid fa-file" style={{ fontSize: '30px' }}></i>
                                                )}

                                               
                                                <div
                                                    className="mt-1 d-flex align-items-center justify-content-between"
                                                    style={{ fontSize: '10px', fontWeight: 'bold', height:'40px' }}
                                                >
                                                    <span className="text-truncate" style={{ maxWidth: '70px' }}>
                                                        {file.uploadFileName}
                                                    </span>

                                                    <i
                                                        className="fa-solid fa-download  ms-1"
                                                        style={{ cursor: 'pointer', fontSize: '12px', color: '#ed522d' }}
                                                        onClick={(e) => {
                                                            e.stopPropagation(); 
                                                            handleDownload(file.uploadFileBase, file.uploadFileName, file.uploadExt);
                                                        }}
                                                    ></i>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {/*<TrackingHistoryStepper movements={movements} />*/}
                    {/*<TrackingHistoryTimeline movements={movements} />*/}
                    {/* ── Tracking History ── */}
                    {movements?.length > 0 && (
                        <div className="card border mt-3">
                            <div className="card-header d-flex align-items-center justify-content-between py-2">
                                <h6 className="m-0 d-flex align-items-center gap-2">
                                    <FiMapPin className="text-danger" />
                                    {FindTranslatedKey('Tracking History')}
                                </h6>

                            </div>

                            <div className="card-body p-0">
                                <div className="table-responsive" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <table className="table table-bordered table-striped mb-0">
                                        <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                            <tr>
                                                <th style={{ fontSize: '12px' }}>{FindTranslatedKey('Status Date')}</th>
                                                <th style={{ fontSize: '12px' }}>{FindTranslatedKey('POD Location')}</th>
                                                <th style={{ fontSize: '12px' }}>{FindTranslatedKey('Status Detail')}</th>
                                                <th style={{ fontSize: '12px' }}>{FindTranslatedKey('Customer Ref No.')}</th>
                                                <th style={{ fontSize: '12px' }}>{FindTranslatedKey('Created Date')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {movements?.map((item, i) => (
                                                <tr key={i}>
                                                    <td style={{ fontSize: '13px' }}>{item.statusDate || '—'}</td>
                                                    <td style={{ fontSize: '13px' }}>
                                                        {item.podLocation
                                                            ? <><FiMapPin size={12} className="text-danger me-1" />{item.podLocation}</>
                                                            : '—'}
                                                    </td>
                                                    <td style={{ fontSize: '13px' }}>{item.statusDetails || '—'}</td>
                                                    <td style={{ fontSize: '13px' }}>{item.referenceNo || '—'}</td>
                                                    <td style={{ fontSize: '13px' }}>{item.statusDate || '—'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* ── No Data ── */}
                    {trackingData && !basic && movements.length === 0 && (
                        <div className="alert alert-warning mt-3">
                            {FindTranslatedKey('No tracking data found.')}
                        </div>
                    )}

                </div>
            </div>

            <Dialog
                open={showModalBox}
                onClose={handleModalDocShowClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={false}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "800px",
                        }

                    },
                    "& .css-hz1bth-MuiDialog-container": {
                        alignItems: 'start'
                    },
                    "& .MuiPaper-root": {
                        width: '95vw',
                        maxWidth: '1000px',
                        borderRadius: '8px',
                    },
                }}>

                <DialogTitle id="alert-dialog-title" className="py-1 px-2 border-bottom d-flex justify-content-between align-items-center" >
                    <div style={{ fontWeight: 500 }}>Document View </div>
                    <div className="d-flex align-items-center gap-3">
                        <i className="fa-solid fa-xmark" onClick={handleModalDocShowClose} title="Close" style={{ cursor: 'pointer', fontSize: '20px', backgroundColor: 'red', padding: '2px', borderRadius: '5px' }} />
                    </div>
                </DialogTitle>

                <DialogContent className='main-card px-0 m-2 py-1' style={{ boxShadow: 'none', }} >

                    {fileExtension.toUpperCase() === 'PDF' ? (
                        <iframe
                            title="PDF Preview"
                            src={generatePdfUrl(base64FileData)}
                            style={{ width: '100%', height: '700px', border: 'none' }}
                        />
                    ) : (
                        <img
                            src={generateImageUrl(base64FileData)}
                            alt="File Preview"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain', }}

                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Tracking;